import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {Router} from "@angular/router"
// import {SimpleGlobal} from 'ngx-simple-global'

declare const analytics
@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class StartComponent implements OnInit {

  constructor(public router: Router/* , public sg:SimpleGlobal */) { }

  ngOnInit(): void {
  }

  gotoFind(){
    this.router.navigate(['/onboarding/find'])
     analytics.track('clicked button', {
      section: 'onboarding', 
      value: 'premium',  // premium
      step: 'choose flow'
    });
  }

  stepsRouter(){
    this.router.navigate(['/onboarding/find'])
  }

  gotoFreetoplay(){
    analytics.track('clicked button', {
      section: 'onboarding', 
      value: 'synthetic',  // premium
      step: 'choose flow'
    });

    this.router.navigate(['/onboarding/pick-starter'])
  }

  gotoHub(){
    this.router.navigate(['/kryptomons'])
  }

}
